import type { TransitionsReqV2 } from '@revelio/data-access';

export const filterEntitiesToFirstEntType = (
  req: TransitionsReqV2
): TransitionsReqV2 => {
  if (req.entities.length <= 1) return req;
  const firstType = req.entities[0]?.EntType;
  if (!firstType) return req;

  return {
    ...req,
    entities: req.entities.filter((e) => e.EntType === firstType),
  };
};
